module.exports = __webpack_public_path__ + "img/sbs-grid-icon.284f573e.webp";